function getStoredBoxImageMap() {
  try {
    const parsed = JSON.parse(localStorage.getItem('box_builder_images') || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

function hydrateBoxImagesInParsedHtml(parsedDocument) {
  const imageMap = getStoredBoxImageMap();
  if (!imageMap || Object.keys(imageMap).length === 0) return;

  parsedDocument.querySelectorAll('[data-box-image-target][data-box-id]').forEach((imageEl) => {
    const boxId = imageEl.getAttribute('data-box-id');
    const imageUrl = boxId ? imageMap[boxId] : null;
    if (!imageUrl) return;

    imageEl.setAttribute('src', imageUrl);
    imageEl.removeAttribute('hidden');

    const mediaWrapper = imageEl.closest('.box-group-card__media');
    const placeholder = mediaWrapper?.querySelector('[data-box-image-placeholder]');
    if (placeholder) {
      placeholder.setAttribute('style', 'display:none');
    }
  });
}

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    hydrateBoxImagesInParsedHtml(parsed);
    const target = parsed.querySelector(selector);
    return target ? target.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
